+(function () {

    $("#arrow-down").click(function() {
        var navHeight = $("#main-nav").height();
        $('html, body').animate({
            scrollTop: $("#game-title").offset().top-navHeight
        }, 250);
    });

})();
